import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wxea5gx4ug: FaireBrandEntity = {
  token: "b_wxea5gx4ug",
  type: "brand",
  name: "Coastal Strands",
  avatarUrl:
    "https://cdn.faire.com/fastly/4da3caccea74463b2ac9c9085ce31a1342fa55df6efbe86891885e5da4385f97.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e36378dff5ecbd607877b934a2bf5fa04121296aa1ca2099210b91d87378a508.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4da3caccea74463b2ac9c9085ce31a1342fa55df6efbe86891885e5da4385f97.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e36378dff5ecbd607877b934a2bf5fa04121296aa1ca2099210b91d87378a508.png",
  location: "Panama city , FL, USA",
  minimumOrderDollars: 69,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Coastal Strands is a modern lifestyle brand offering stylish, affordable clothing and home goods for women and men who value quality, comfort, and effortless design. Inspired by coastal living and everyday simplicity, our collections blend contemporary fashion with timeless details to create pieces that feel elevated yet easy to wear and live with.\n\nOur apparel focuses on clean silhouettes, versatile staples, and trend-forward pieces that transition seamlessly from day to night. Our home goods collection reflects the same philosophy, thoughtfully designed decor, and essentials that bring warmth, functionality, and modern charm into any space.\n\nAt Coastal Strands, we care deeply about quality, affordability, and customer experience. We carefully select materials, prioritize fit and comfort, and design collections that feel fresh, functional, and long-lasting. Our mission is to provide fashion-forward clothing and stylish home pieces that make everyday life feel a little more beautiful.\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:05.190Z",
    importedBy: "entity-db-cli",
  },
};
